import { render, staticRenderFns } from "./EventPackageOfferHotelsList.vue?vue&type=template&id=d1f155e8&"
import script from "./EventPackageOfferHotelsList.vue?vue&type=script&lang=js&"
export * from "./EventPackageOfferHotelsList.vue?vue&type=script&lang=js&"
import style0 from "./EventPackageOfferHotelsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports